module.exports = __webpack_public_path__ + "static/img/4bg_13.6c297a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_13.png
// module id = 698
// module chunks = 1